'use client';
import { objectKeys } from '../object.js';

/**
 * Создаёт новый объект, включая в него только определённые свойства
 * (свойства, значения которых не undefined).
 *
 * @typeParam Type - Record произвольной структуры.
 *
 * @param object - Произвольный объект.
 *
 * @returns Новый объект, включающий все свойства изначального, кроме тех, для которых значение undefined.
 *
 * @example Удаление undefined полей:
 *
 * ```ts
 * cloneDefined({ a: undefined, b: 2 }) // { b: 2 }
 * ```
 * */ var cloneDefined = function(object) {
    return objectKeys(object).reduce(function(target, key) {
        if (object[key] !== undefined) {
            target[key] = object[key];
        }
        return target;
    }, {});
};

export { cloneDefined };
